
    <div id="acceptDiv" *ngIf="showAccept" >
        <div class="modal-header">
            <h4 class="modal-title pull-left">Accept Offer</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">

            <div class="form-group">

                <div class="row">
                    <div class="col-sm-12">
                        <div class="margin-bottom-15">
                            <label class="form-label">Accept offer on Behalf of</label>
                            <label class="select">
                                <select class="form-control " [(ngModel)]="optionSelected" [disabled]="IsExternalBroker">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let option of options" [(ngValue)]="option.id">{{option.name}}</option>
                                </select>
                                <i></i>
                            </label>
                        </div>
                    </div>
               
                </div>
                <div class="mt_-15">

                    <!--<file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) [uploadType]="fileUploadType" [extensionType]="fileExtensionType" [showList]="true" [clearFilescounter]="clearFiles"></file-upload>-->
                    <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="1" [extensionType]="fileExtensionType" [extensionLOIType]="fileExtensionLOIType" [clearFilescounter]="clearFiles" [fileTypes] ="fileTypes"></file-upload>

                </div>

                <!--<div class="form-group">
                    <textarea class="form-control textarea-min-height" maxlength="4000"  required type="text" placeholder="Please enter comments"></textarea>
                    <p class="redtext">Please enter comments </p>
                </div>-->
                <div class="text-right padding_15_0">
                    <!--<button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>-->
                    <button type="button" (click)="sendEmailModal()" [disabled]="disabledAcceptBtn" class="btn btn-success btn-lg">Accept</button>
                </div>
            </div>
        </div>
    </div>



    <div id="rejectDiv" *ngIf="!showAccept">
        <div class="modal-header">
            <h4 class="modal-title pull-left"> Reject Offer</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">

            <div class="form-group">

                <div class="row">
                    <div class="col-sm-12">
                        <div class="margin-bottom-15">
                            <label class="form-label">Reject on Behalf of</label>
                            <label class="select">
                                <select class="form-control " [(ngModel)]="optionSelected">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let option of options" [(ngValue)]="option.id">{{option.name}}</option>
                                </select>
                                <i></i>
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        &nbsp;
                    </div>
                </div>
                <div class="row">

                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Any other comments to supplement your offer?</label>
                            <textarea class="form-control" maxlength="999" [(ngModel)]="comments"></textarea>
                        </div>
                    </div>


                </div>

                <!--<div class="form-group">
                    <textarea class="form-control textarea-min-height" maxlength="4000"  required type="text" placeholder="Please enter comments"></textarea>
                    <p class="redtext">Please enter comments </p>
                </div>-->
                <div class="text-right padding30">
                    
                    <button type="button" (click)="rejectOffer()" class="btn btn-success btn-lg">Reject</button>
                </div>
            </div>
        </div>
    </div>

    <ng-template #sendEmail>
      <div class="modal-header">
        <h4 class="modal-title pull-left">Send Notification</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body padding30">

        <div class="form-group">
          <h6 class="displayvalue">Would you like to notify principal?</h6>
        </div>
        <div class="text-right">
          <button class="btn btn-lg btn-default" (click)="acceptOffer(0);modalRefSendEmail.hide()">No</button>
          <button class="btn btn-success btn-lg" (click)="acceptOffer(1);modalRefSendEmail.hide();">Yes</button>
        </div>
      </div>
    </ng-template>
